// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__34KmS","clinicsSelect":"TableHeading_clinicsSelect__3O5u2"};